// AUTO-GENERATED by scripts/extract-tiger-resources.mjs — do not edit by hand.
// Source: libTres/tiger_resource.cpp default_resources[].
export const TIGER_RESOURCES: Record<string, string> = {
  "DIAG_ACCOUNTS_FOR_RES": "Accounts for",
  "DIAG_AREA_REPORT_RES": "Area reports",
  "DIAG_COMPLETE_REPORT_RES": "Complete message listing in time order for",
  "DIAG_DETERMINED_BY_RES": "Determined by",
  "DIAG_HEADER_REPORT_RES": "Tiger report",
  "DIAG_HIGHEST_CURRENT_RES": "Highest Value: %s Current Value: %s",
  "DIAG_INITIAL_DIAGNOSTIC_RES": "[  Initial  Diagnostic  ]",
  "DIAG_LOWEST_CURRENT_RES": "Lowest Value: %s Current Value: %s",
  "DIAG_MSG_O_1": ") changed from 0 to 1",
  "DIAG_MSG_1_0": ") changed from 1 to 0",
  "DIAG_MSG_AREA": "Reports in area: ",
  "DIAG_MSG_CHECKER_ANALOG": "Analog checker (",
  "DIAG_MSG_CHECKER_DELTA": "Delta checker (",
  "DIAG_MSG_CHECKER_DIGITAL": "Digital checker (",
  "DIAG_MSG_CHECKER_FOLLOW": "Follows checker (",
  "DIAG_MSG_CHECKER_GRAD": "Gradient checker (",
  "DIAG_MSG_CHECKER_INV": "Inv. Follows checker (",
  "DIAG_MSG_CHECKER_HLR": "High Level Rule checker (",
  "DIAG_MSG_CHECKER_LOGIC": "Logic checker (",
  "DIAG_MSG_CHECKER_RULE": "Rule checker (",
  "DIAG_MSG_CHECKER_STEP": "Step checker (",
  "DIAG_MSG_FAILED_SENSOR": "Sensor Problem. ",
  "DIAG_MSG_FOLLOW_FAILED": ") failed to follow ",
  "DIAG_MSG_FOLLOW_FAILED_SECS": ") failed to follow within %s seconds",
  "DIAG_MSG_FOLLOW_SECS_A": ") within %s seconds. Tolerance %s ",
  "DIAG_MSG_FOLLOW_SECS_D": ") within %s seconds",
  "DIAG_MSG_INV_FOLLOW_FAILED": ") failed to inversely follow ",
  "DIAG_MSG_INV_FOLLOW_FAILED_SECS": ") failed to inversely follow within %s seconds",
  "DIAG_MSG_GRAD_H": ")- significant increase. Limit %s ",
  "DIAG_MSG_GRAD_L": ")- significant decrease. Limit %s ",
  "DIAG_MSG_H_HH": ") too high high. Limit %s ",
  "DIAG_MSG_HH_HHH": ") too high high high. Limit %s ",
  "DIAG_MSG_L_LL": ") too low low. Limit %s ",
  "DIAG_MSG_LL_LLL": ") too low low low. Limit %s ",
  "DIAG_MSG_N_H": ") too high. Limit %s ",
  "DIAG_MSG_N_L": ") too low. Limit %s ",
  "DIAG_MSG_STEP_H": ")- step increase of more than %s ",
  "DIAG_MSG_STEP_L": ")- step decrease of more than %s ",
  "DIAG_MSG_STEP_SECS": " in %s seconds",
  "DIAG_MSG_SUMREP": ") not in expected state (actual %s expected %s)",
  "DIAG_MSG_TRIGGER": ") has triggered",
  "DIAG_MSG_TSTATE_0": "The turbine is not in state: ",
  "DIAG_MSG_TSTATE_1": "The turbine is in state: ",
  "DIAG_OCCURED_RES": "occured %d times in time interval %s to %s",
  "DIAG_OCCURED_TIMES_RES": "occurred %d times",
  "DIAG_OCCURED_TIME_RES": "occurred 1 time",
  "DIAG_OTHER_AREA_RES": "Other Faults Present in Area",
  "DIAG_SUMMARY_REPORT_RES": "Summary report of current state",
  "TIGERUI_ABOUT": "About Tiger...",
  "TIGERUI_ADVANCED": "Advanced",
  "TIGERUI_ADVANCED_BINARY": "Data File Selection",
  "TIGERUI_ADVANCED_RELOAD_DIAG": "Reload Diagnostics...",
  "TIGERUI_ADVANCED_REMOTE": "Remote Download",
  "TIGERUI_ADVANCED_SAVE_TREND": "Save Default Trend...",
  "TIGERUI_ADVANCED_TREND": "Trend File Selection...",
  "TIGERUI_BACKUP": "Backup Data",
  "TIGERUI_BLADEPATH": "Blade Path",
  "TIGERUI_CHANGE_PASSWORD": "Change Password...",
  "TIGERUI_CLOSE_ALL_TOOL_WIN": "Close All Tool Windows",
  "TIGERUI_COPY_VIEW": "Copy View To Clipboard",
  "TIGERUI_DATAGRID_RES": "Data Grid",
  "TIGERUI_DIAG": "Diagnostics",
  "TIGERUI_DIAG_CLEAR": "Clear Window",
  "TIGERUI_DIAG_FILTERS": "Filters...",
  "TIGERUI_DIAG_HIST": "Historical Diagnostics",
  "TIGERUI_DIAG_RUN": "Run Query...",
  "TIGERUI_DISPLAY_DIAG": "Display Diagnostics",
  "TIGERUI_DISPLAY_DISTRIBUTION": "Display Distribution",
  "TIGERUI_DISPLAY_GRAPH": "Display Graph",
  "TIGERUI_DISPLAY_GRAPH_SET": "Display Graph Set",
  "TIGERUI_DISPLAY_TREND": "Display Trend",
  "TIGERUI_DISPLAY_TREND_30": "Display 30 days Trend",
  "TIGERUI_DISPLAY_TREND_180": "Display 6 month Trend",
  "TIGERUI_DISPLAY_TREND_365": "Display 1 year Trend",
  "TIGERUI_DISPLAY_TREND_SET": "Display Trend Set",
  "TIGERUI_DISPLAY_TREND_SET_30": "Display 30 days Trend Set",
  "TIGERUI_DISPLAY_TREND_SET_180": "Display 6 month Trend Set",
  "TIGERUI_DISPLAY_TREND_SET_365": "Display 1 year Trend Set",
  "TIGERUI_DISTRIB": "Distribution",
  "TIGERUI_DISTRIB_GRAPH": "Graph",
  "TIGERUI_DISTRIB_HIST_GRAPH": "Historical Graph",
  "TIGERUI_DISTRIB_SELECT": "Select Time...",
  "TIGERUI_DOWNLOAD_BINARY": "Controller Data...",
  "TIGERUI_DOWNLOAD_DAILY": "Daily Data...",
  "TIGERUI_EMISSION": "Emission",
  "TIGERUI_ENGINES": "Engines",
  "TIGERUI_EXIT": "Exit...",
  "TIGERUI_EXPORT": "Export",
  "TIGERUI_EXPORT_DATA": "Data...",
  "TIGERUI_EXPORT_TREND": "Trend...",
  "TIGERUI_FILE": "File",
  "TIGERUI_FREEZE_UPDATES": "Freeze Updates",
  "TIGERUI_GRAPH": "Graph",
  "TIGERUI_GRAPH_BODE": "Bode",
  "TIGERUI_GRAPH_DATA": "Data",
  "TIGERUI_GRAPH_EVENT": "Event Graph",
  "TIGERUI_GRAPH_MULTI": "Multi-time",
  "TIGERUI_GRAPH_NYQUIST": "Nyquist Graph",
  "TIGERUI_GRAPH_ORBIT": "Orbit Graph",
  "TIGERUI_GRAPH_SPECTRUM": "Spectrum",
  "TIGERUI_GRAPH_TARGET": "Target Graph",
  "TIGERUI_GRAPH_WATERFALL": "Waterfall",
  "TIGERUI_GRAPH_XY": "X-Y",
  "TIGERUI_HISTORICAL_GRAPH": "Historical Graph",
  "TIGERUI_HELP": "Help",
  "TIGERUI_LANG": "Set Language",
  "TIGERUI_LOAD_DATA": "Load Data",
  "TIGERUI_LOAD_MODEL": "Load Model Data...",
  "TIGERUI_MANUALS": "Manuals",
  "TIGERUI_MANUALS_ALTERNATORE": "Alternatore",
  "TIGERUI_MANUALS_REMOTE": "Remote Manual",
  "TIGERUI_MANUALS_SISTEMI": "Sistemi Ausiliari",
  "TIGERUI_MANUALS_TIGER": "Using Tiger",
  "TIGERUI_MANUALS_TURBINE": "Turbine Manuals",
  "TIGERUI_MANUALS_TURBOGAS": "Turbogas",
  "TIGERUI_MODELS": "Models",
  "TIGERUI_PRINT": "Print...",
  "TIGERUI_RELOAD_VIEWS": "Reload Views...",
  "TIGERUI_REPLAY_CONT": "Continue Replay",
  "TIGERUI_REPLAY_DECREASE": "Decrease",
  "TIGERUI_REPLAY_FILES": "Select File(s)...",
  "TIGERUI_REPLAY_INCREASE": "Increase",
  "TIGERUI_REPLAY_JUMP_BACK": "Jump Backward",
  "TIGERUI_REPLAY_JUMP_FORWARD": "Jump Forward",
  "TIGERUI_REPLAY_NEXT": "Load Next...",
  "TIGERUI_REPLAY_PAUSE": "Pause Replay",
  "TIGERUI_REPLAY_PREV": "Load Previous...",
  "TIGERUI_REPLAY_RECENT": "Recent Data",
  "TIGERUI_REPLAY_RESET": "Reset",
  "TIGERUI_REPLAY_SELECT": "Select Time...",
  "TIGERUI_REPLAY_START": "Start Replay",
  "TIGERUI_REPLAY_STEP": "Step Replay",
  "TIGERUI_REPLAY_STOP": "Stop Replay",
  "TIGERUI_REPLAY_TOOLBAR": "Replay Toolbar",
  "TIGERUI_REPLAY_UPDATE": "Update Rate",
  "TIGERUI_REPORTS": "Reports",
  "TIGERUI_REPORT_AIR": "Filtri Aspirazione",
  "TIGERUI_REPORT_COMPARE": "Report Compare",
  "TIGERUI_REPORT_EMISSION": "Emissioni NOx",
  "TIGERUI_REPORT_EQUIV": "Ore Equivalenti",
  "TIGERUI_REPORT_GAS": "Composizione Gas",
  "TIGERUI_REPORT_MAINTENANCE": "Maintenance",
  "TIGERUI_REPORT_NOX": "NOx Emission",
  "TIGERUI_REPORT_STABILITY": "Performance Stability",
  "TIGERUI_REPORT_VALUES": "Controller Values",
  "TIGERUI_RESTORE": "Restore Data",
  "TIGERUI_SAVE_VIEW": "Save View...",
  "TIGERUI_SET_TIME": "Set Time...",
  "TIGERUI_SHOW_ALL_TOOL_WIN": "Show All Tool Windows",
  "TIGERUI_SIGN_OUT": "Sign Out",
  "TIGERUI_START_TIGER": "Start Tiger",
  "TIGERUI_TEST_DATA": "Test Data Creation...",
  "TIGERUI_TOOLS": "Tools",
  "TIGERUI_TOOL_SETS": "Tool Sets...",
  "TIGERUI_TOOL_WINS_SAVE": "Save Tools as Report ...",
  "TIGERUI_TREND": "Trend",
  "TIGERUI_TREND_GRAPH": "Graph",
  "TIGERUI_TREND_HIST_GRAPH": "Historical Graph",
  "TIGERUI_TREND_HIST_SELECT": "Historical Select",
  "TIGERUI_TREND_HIST_XYGRAPH": "Historical X-Y",
  "TIGERUI_TREND_MULTI_XYGRAPH": "Multi X-Y",
  "TIGERUI_TREND_SELECT_CUSTOM": "Select Customised...",
  "TIGERUI_TREND_SELECT_DAILY": "Select Daily...",
  "TIGERUI_TREND_SELECT_TIME": "Select Time...",
  "TIGERUI_TREND_XYGRAPH": "X-Y",
  "TIGERUI_VIBRATION": "Vibration",
  "TIGERUI_WINDOW": "Window",
  "TIGER_ABOUT_CONFIG": "Configuration version : ",
  "TIGER_ABOUT_GRAPH": "Graphing: Portions by ComponentOne. Copyright ComponentOne LLC 1991-2001. All Rights Reserved",
  "TIGER_ABOUT_RULE": "Rulebase version : ",
  "TIGER_ABOUT_RUNTIME": "Runtime version : ",
  "TIGER_ABOUT_TIGER": "Tiger Knowledge Base Turbine Monitoring",
  "TIGER_ABOUT_TITLE": "About Tiger",
  "TIGER_ABOUT_TRADEMARK": "Copyright 1992-2026, Chromalloy Turbine Services, All rights reserved. Tiger is a registered trademark of Chromalloy Turbine Services in the United Kingdom and other countries.",
  "TIGER_ABOUT_VIEWS": "Screens version : ",
  "TIGER_ADDIN_APPEND": "Add a row on each refresh",
  "TIGER_ADDIN_AUTO": "Refresh automatically (while this pane is open)",
  "TIGER_ADDIN_AUTO_MINS": "Every %s min",
  "TIGER_ADDIN_AUTO_OFF": "Off",
  "TIGER_ADDIN_AUTO_SECS": "Every %s s",
  "TIGER_ADDIN_AUTO_UPDATED": "Current values updated at %s.",
  "TIGER_ADDIN_BAD_TOKEN": "This site refused %s with that token. The user name must be exactly the one you signed in with to create the token; or get a new token.",
  "TIGER_ADDIN_CANCEL": "Cancel",
  "TIGER_ADDIN_CANCELLED": "Cancelled.",
  "TIGER_ADDIN_CHANGE": "Change",
  "TIGER_ADDIN_END": "End",
  "TIGER_ADDIN_END_DATE": "End date",
  "TIGER_ADDIN_END_TIME": "End time",
  "TIGER_ADDIN_GET_TOKEN": "Get a token",
  "TIGER_ADDIN_IMPORT": "Import Data",
  "TIGER_ADDIN_INSERTED": "%s rows imported into table %s.",
  "TIGER_ADDIN_NO_LIVE": "No live data from %s yet. Try again in a moment.",
  "TIGER_ADDIN_NOT_IN_EXCEL": "Open this pane from Excel (Home > Tiger Data) to insert data.",
  "TIGER_ADDIN_PROGRESS_DAY": "Day %s of %s (%s)",
  "TIGER_ADDIN_PROGRESS_HOUR": "Hour %s of %s (%s)",
  "TIGER_ADDIN_PROGRESS_WAIT": "Waiting for the data server...",
  "TIGER_ADDIN_SAMPLE_RATE": "Sample rate (s)",
  "TIGER_ADDIN_SAVE": "Save",
  "TIGER_ADDIN_SHEET_NEW": "The data goes into a new table at A1 of this sheet (or of a new sheet if this one holds other data).",
  "TIGER_ADDIN_SHEET_TABLE": "This sheet's table is %s. It uses the tags ticked and the settings above.",
  "TIGER_ADDIN_SIGNED_IN": "Signed in as %s",
  "TIGER_ADDIN_SIGN_IN": "Sign in with your user name and an access token for this site.",
  "TIGER_ADDIN_START": "Start",
  "TIGER_ADDIN_START_DATE": "Start date",
  "TIGER_ADDIN_START_TIME": "Start time",
  "TIGER_ADDIN_TAG_TYPE": "Tag type",
  "TIGER_ADDIN_TITLE": "Tiger Data",
  "TIGER_ADDIN_TOKEN": "Access token",
  "TIGER_ADDIN_UPDATE_NOW": "Update now",
  "TIGER_ADDIN_USER": "User name",
  "TIGER_ADDIN_WORKING": "Working...",
  "TIGER_AIR_DATA": "Air Filter data is not available",
  "TIGER_ALARM_TITLE": "%s: Tiger Alarm Server",
  "TIGER_ALL_TURBINES": "All turbines",
  "TIGER_BACKING_MSG": "Backing up of the tiger configuration files.\n\nPlease Wait ...",
  "TIGER_BACKING_CONFIG": "Backing up of the directory %s.\n\nPlease Wait ...",
  "TIGER_BACKING_TITLE": "Backing up of configs",
  "TIGER_BACKUP_DATA_LOCATION": "Select the location for the backup of the data",
  "TIGER_BACKUP_DATA_TITLE": "Backing up of Tiger data",
  "TIGER_BACKUP_FAIL": "Tiger backup failed",
  "TIGER_BACKUP_LOCATION_ERROR": "Please select the location of the data backup",
  "TIGER_BACKUP_PROGRESS_MSG": "Backing up data from %s to %s",
  "TIGER_BACKUP_SUCCESS": "Tiger backup succeeded",
  "TIGER_BROWSE_BUTTON": "Browse ...",
  "TIGER_BROWSE_COMPARE_CDROM": "Data cdrom request : ",
  "TIGER_BROWSE_DATA_CDROM": "Data cdrom request : ",
  "TIGER_BROWSE_DATA_LOAD": "Load data from :",
  "TIGER_BROWSE_DIAG_CDROM": "Query Diagnostics cdrom request : ",
  "TIGER_BROWSE_DISTRIB_CDROM": "Distribution cdrom request : ",
  "TIGER_BROWSE_EXPORT_CDROM": "Exporting data cdrom request : ",
  "TIGER_BROWSE_MODEL_CDROM": "Model cdrom request : ",
  "TIGER_BROWSE_SELECT": "Select Browse Folder",
  "TIGER_BROWSE_TREND_CDROM": "Trend cdrom request : ",
  "TIGER_CHANNEL_ACTIVETIME": "Active Time",
  "TIGER_CHANNEL_CUR": "Current",
  "TIGER_CHANNEL_DESCR": "Description",
  "TIGER_CHANNEL_EVENT": "Event",
  "TIGER_CHANNEL_HIST": "Historical",
  "TIGER_CHANNEL_PATTERN": "Pattern Matching",
  "TIGER_CHANNEL_TAG": "Tag",
  "TIGER_CHANNEL_TIMES": "Times",
  "TIGER_CHANNEL_TYPE": "Channel Type",
  "TIGER_CONERROR": "Connection Error",
  "TIGER_CONNECTED": "Connected",
  "TIGER_CONNECTING": "Connecting",
  "TIGER_CONNECT_HANGUP": "Hang up the connection when finished",
  "TIGER_CONNECT_TO": "Connecting to ",
  "TIGER_CONT_LOW_ALARM": "Controller Low Alarm Value: %.2f ",
  "TIGER_CONT_LOW_TRIP": "Controller Low Trip Value: %.2f ",
  "TIGER_CONT_HIGH_ALARM": "Controller High Alarm Value: %.2f ",
  "TIGER_CONT_HIGH_TRIP": "Controller High Trip Value: %.2f ",
  "TIGER_CONTROL_PAGE": "Page %d",
  "TIGER_CONTROL_TITLE": "Controller Values report for turbine %s at %s",
  "TIGER_DAILY_MODEL_DAY": "Model for day",
  "TIGER_DAILY_MODEL_LOAD": "Load Model Data",
  "TIGER_DAILY_TREND_DAY": "Trend for day",
  "TIGER_DAILY_TREND_LOAD": "Load Daily Trend",
  "TIGER_DATAGRID_DESCR": "Description",
  "TIGER_DATAGRID_HIGHDCS": "High DCS",
  "TIGER_DATAGRID_HIGHDIAG": "High Diag",
  "TIGER_DATAGRID_LOWDCS": "Low DCS",
  "TIGER_DATAGRID_LOWDIAG": "Low Diag",
  "TIGER_DATAGRID_STATE": "State",
  "TIGER_DATAGRID_TAGNAME": "Tag Name",
  "TIGER_DATAGRID_TURBINE": "Turbine",
  "TIGER_DATAGRID_VALUE": "Value",
  "TIGER_DATA_TOKEN_BACK": "Back to Tiger",
  "TIGER_DATA_TOKEN_COPIED": "Copied",
  "TIGER_DATA_TOKEN_COPY": "Copy",
  "TIGER_DATA_TOKEN_CREATE": "Create Token",
  "TIGER_DATA_TOKEN_CREATING": "Creating...",
  "TIGER_DATA_TOKEN_EXPIRES": "Expires %s",
  "TIGER_DATA_TOKEN_FAILED": "Could not create a token.",
  "TIGER_DATA_TOKEN_INTRO": "Excel reads this site's turbine data with Power Query: Data > Get Data > From Web. When it asks how to sign in, choose Basic and enter your user name, with an access token as the password.",
  "TIGER_DATA_TOKEN_NOT_NEEDED": "Sign-in is off on this site, so Excel needs no token: choose Anonymous in Power Query.",
  "TIGER_DATA_TOKEN_QUERY_LINK": "Build an address for Excel",
  "TIGER_DATA_TOKEN_SITE": "Works on site %s only",
  "TIGER_DATA_TOKEN_TITLE": "Excel Data Access",
  "TIGER_DATA_TOKEN_TOKEN": "Password (access token)",
  "TIGER_DATA_TOKEN_USER": "User name",
  "TIGER_DATA_TOKEN_WARNING": "Copy the token now: it is not shown again. Anyone who has it can read this site's data until it expires or your password changes.",
  "TIGER_DATA_LOADED_MSG": "The replay data has been loaded. Do you want to start the replay now ?",
  "TIGER_DATA_LOADED_TITLE": "Replay Loaded",
  "TIGER_DIAG_ABOUT": "About ...",
  "TIGER_DIAG_ACTIVE_LABEL": "Check Active Time for the Diagnostics: ",
  "TIGER_DIAG_ACTIVE_TITLE": "Diagnostics Active Time",
  "TIGER_DIAG_ALMS": " alarms:",
  "TIGER_DIAG_ALM_ALM": "alarm",
  "TIGER_DIAG_ALM_DALM": "dalarm",
  "TIGER_DIAG_ALM_EVT": "event",
  "TIGER_DIAG_ALM_PALM": "palarm",
  "TIGER_DIAG_ALM_TRIP": "trip",
  "TIGER_DIAG_AREA": " area:",
  "TIGER_DIAG_CANCELLED": "Query was cancelled",
  "TIGER_DIAG_CHANGE": "Change Query",
  "TIGER_DIAG_DISPLAY_LATCH": "Display Latched Messages",
  "TIGER_DIAG_DISTRIB": "Display Distribution",
  "TIGER_DIAG_DOWNLOAD": "Downloading of diagnostic data in progress, please wait",
  "TIGER_DIAG_ENDT_INV": "The end time is invalid",
  "TIGER_DIAG_FAILED": "Query failed because the diagnostics collector process did not reply",
  "TIGER_DIAG_FILTER": "Filter",
  "TIGER_DIAG_FILTER_ADD": "Add To Filter",
  "TIGER_DIAG_FILTER_DATE": "Date Filtered",
  "TIGER_DIAG_FILTER_INV": "inverse",
  "TIGER_DIAG_FILTER_MES": "Message",
  "TIGER_DIAG_FILTER_MESID": "Message ID",
  "TIGER_DIAG_FILTER_OFF": "off",
  "TIGER_DIAG_FILTER_ON": "on",
  "TIGER_DIAG_FILTER_REMOVE": "Remove From Filter",
  "TIGER_DIAG_FILTER_TITLE": "Diagnostics Filter",
  "TIGER_DIAG_FILTER_TURBINE": "Turbine",
  "TIGER_DIAG_FIND": "Find",
  "TIGER_DIAG_FIND_STR": "%s was not found",
  "TIGER_DIAG_FIND_TITLE": "Diagnostics",
  "TIGER_DIAG_FROM": " from ",
  "TIGER_DIAG_GRAPH": "Display Graph",
  "TIGER_DIAG_HIST_TITLE": "Historical Diagnostics",
  "TIGER_DIAG_ID": "Display ID",
  "TIGER_DIAG_IN_PROGRESS": "Query in progress",
  "TIGER_DIAG_LOST": "Connection to %s has been lost. Reconnecting ...",
  "TIGER_DIAG_LATCH_MSG": "Latched Messages",
  "TIGER_DIAG_MANUAL_DXF": "Schematic: ",
  "TIGER_DIAG_MANUAL_OPEN": "Document: ",
  "TIGER_DIAG_MANUAL_PDF": "Document: ",
  "TIGER_DIAG_MANUAL_PDI": "Display: ",
  "TIGER_DIAG_MANUAL_TXT": "Procedure: ",
  "TIGER_DIAG_MID": " id:",
  "TIGER_DIAG_MODULE": "Diagnostics Module",
  "TIGER_DIAG_MSG": " message:",
  "TIGER_DIAG_MSG_TITLE": "Diagnostics Query",
  "TIGER_DIAG_NODIAG": "Query is complete there are no diagnostics to display",
  "TIGER_DIAG_NOTE_CREATE": "Create Notes",
  "TIGER_DIAG_NOTE_EDIT": "Edit Notes",
  "TIGER_DIAG_PRINT": "Print",
  "TIGER_DIAG_PROP_ALARM": "Alarms",
  "TIGER_DIAG_PROP_FILTER": "Filter",
  "TIGER_DIAG_PROP_GENERAL": "General",
  "TIGER_DIAG_PROP_QUERY": "Query",
  "TIGER_DIAG_QUERY_AREA": " by area",
  "TIGER_DIAG_QUERY_AREA_OUT": "Currently abnormal diagnostics by area for turbine ",
  "TIGER_DIAG_QUERY_AREA_OCC": " by area  and occurrences",
  "TIGER_DIAG_QUERY_AREA_INVALID": "Disabled Diagnostics query by area for turbine ",
  "TIGER_DIAG_QUERY_AREA_LIST": "Diagnostics List by area for turbine ",
  "TIGER_DIAG_QUERY_DCS": "DCS Alarms diagnostics for turbine ",
  "TIGER_DIAG_QUERY_FAILED_SENSOR": "Failed Sensor ",
  "TIGER_DIAG_QUERY_LIST": "Diagnostics List for turbine ",
  "TIGER_DIAG_QUERY_NBOCC": " by occurrence",
  "TIGER_DIAG_QUERY_OUT": "Currently abnormal diagnostics for turbine ",
  "TIGER_DIAG_QUERY_TIME": " by time",
  "TIGER_DIAG_QUERY_TOP": " by time ( top level only )",
  "TIGER_DIAG_QUERY_TURBINE": "Diagnostics query for turbine ",
  "TIGER_DIAG_QUERY_INVALID": "Disabled Diagnostics query for turbine ",
  "TIGER_DIAG_REFRESH": "Refresh",
  "TIGER_DIAG_REPLAY_FROM": "Replay From %s",
  "TIGER_DIAG_SAREA": "area:",
  "TIGER_DIAG_SAVE": "Save",
  "TIGER_DIAG_SAVE_TITLE": "Save Diagnostics File As",
  "TIGER_DIAG_SEVS": " severities:",
  "TIGER_DIAG_SEV_CRIT": "critical",
  "TIGER_DIAG_SEV_EVT": "event",
  "TIGER_DIAG_SEV_FAULT": "fault",
  "TIGER_DIAG_SEV_INFO": "information",
  "TIGER_DIAG_SEV_TRIP": "trip",
  "TIGER_DIAG_SEV_WARN": "warning",
  "TIGER_DIAG_SFILTER": " filter: ",
  "TIGER_DIAG_SMSG": " msg:",
  "TIGER_DIAG_SORT": "Sort By",
  "TIGER_DIAG_SORT_ID": "Message ID",
  "TIGER_DIAG_SORT_MSG": "Message",
  "TIGER_DIAG_SORT_OCC": "Number Of Occurrences",
  "TIGER_DIAG_SORT_REVERSE": "Reverse Time Order",
  "TIGER_DIAG_SORT_SEVERITY": "Severity",
  "TIGER_DIAG_SORT_TIME": "Time Order",
  "TIGER_DIAG_SQUERY_AREA_LIST": "List by area for",
  "TIGER_DIAG_SQUERY_DCS": "DCS Alarms for",
  "TIGER_DIAG_SQUERY_AREA_INVALID": "Disabled by area for",
  "TIGER_DIAG_SQUERY_LIST": "List for",
  "TIGER_DIAG_SQUERY_OUT": "Currently abnormal for",
  "TIGER_DIAG_SQUERY_INVALID": "Disabled for",
  "TIGER_DIAG_STAG": " tag:",
  "TIGER_DIAG_STARTT_INV": "The start time is invalid",
  "TIGER_DIAG_TAG": " tag:",
  "TIGER_DIAG_TITLE": "Diagnostics",
  "TIGER_DIAG_TO": " to ",
  "TIGER_DIAG_TOOLBAR": "Toolbar",
  "TIGER_DIAG_TOOLS": "Tools",
  "TIGER_DIAG_TREND": "Display Trend",
  "TIGER_DIAG_WAITING": "Waiting for a time for the query to be specified.",
  "TIGER_DIAG_WITH": " with",
  "TIGER_DIAG_WITH_FILTER": " with filter",
  "TIGER_DISCONNECTED": "Disconnected",
  "TIGER_DISCONNECTING": "Disconnecting",
  "TIGER_DISTRIB_DATA_REQ": "Distribution Data Request",
  "TIGER_DISTRIB_FAILED": "Failed to write analog checker file :\n",
  "TIGER_DISTRIB_PROGRESS_MSG": "Distribution from %s to %s",
  "TIGER_DISTRIB_PROGRESS_TITLE": "Distribution Progress : ",
  "TIGER_DISTRIB_UPDATE_TITLE": "Distribution Update Error",
  "TIGER_DOWNLOAD_BYTES": "Downloaded %s of %s bytes",
  "TIGER_DOWNLOAD_CONNECT": "Connecting to Download Server ...",
  "TIGER_DOWNLOAD_DAILY_DISTRIB": "Distributions",
  "TIGER_DOWNLOAD_DAILY_MES": "Messages",
  "TIGER_DOWNLOAD_DAILY_MODEL": "Models",
  "TIGER_DOWNLOAD_DAILY_TITLE": "Download Daily Data",
  "TIGER_DOWNLOAD_DAILY_TREND": "Trend",
  "TIGER_DOWNLOAD_DATA": "Data to Download",
  "TIGER_DOWNLOAD_DATA_REQ": "Download Data",
  "TIGER_DOWNLOAD_END_DATE": "Download End Date",
  "TIGER_DOWNLOAD_END_TIME": "Enter the time to end download",
  "TIGER_DOWNLOAD_FAIL_ALARM": "Download failed : Multi turbine server failed to connect to the turbine. \n Please try again Later.",
  "TIGER_DOWNLOAD_FAIL_BAD": "Download failed : Bad connection",
  "TIGER_DOWNLOAD_FAIL_DATA": "Download failed : Failed to access the data in the remote machine",
  "TIGER_DOWNLOAD_FAIL_DIR": "Download failed : Bad directory",
  "TIGER_DOWNLOAD_FAIL_DISK": "Download failed : Not enough disk space",
  "TIGER_DOWNLOAD_FAIL_FOUND": "Download failed : No data found",
  "TIGER_DOWNLOAD_FAIL_GENERAL": "Download failed : General Failure",
  "TIGER_DOWNLOAD_FAIL_LOCAL": "Download failed : Failed to connect to local download daemon.",
  "TIGER_DOWNLOAD_FAIL_LOST": "Download failed : Lost Connection",
  "TIGER_DOWNLOAD_FAIL_READ": "Download failed : Bad read",
  "TIGER_DOWNLOAD_FAIL_REQ": "Download failed : Failed to send request",
  "TIGER_DOWNLOAD_FAIL_TUNNEL": "Download failed : Connection to tunnel failed.",
  "TIGER_DOWNLOAD_FAIL_UNKNOWN": "Download failed : Unknown Reason",
  "TIGER_DOWNLOAD_FAIL_UNZIP": "Download failed : Failed to unzip data files",
  "TIGER_DOWNLOAD_FAIL_WRAP": "Download failed : Wrap up function failed",
  "TIGER_DOWNLOAD_FAIL_ZIP": "Download failed : Failed to zip data files",
  "TIGER_DOWNLOAD_PROGRESS_TITLE": "Remote Download Progress",
  "TIGER_DOWNLOAD_RATE": "Transfer rate : %s Kb/sec",
  "TIGER_DOWNLOAD_START_DATE": "Download Start Date",
  "TIGER_DOWNLOAD_START_TIME": "Enter the time to start download from",
  "TIGER_DOWNLOAD_TIME": "Estimated time : %s min %s sec",
  "TIGER_EQUIV_DATA": "Equivalent Hours data is not available",
  "TIGER_ERROR": "Error",
  "TIGER_ERROR_ALLOCBIT": "Unable to Allocate Bitmap Memory",
  "TIGER_ERROR_ALTERNATORE_MANUAL": "Alternatore Manual not found",
  "TIGER_ERROR_BUSY": "Tiger for turbine %s is busy. Please try again later",
  "TIGER_ERROR_CREATBIT": "Unable to Create Bitmap File",
  "TIGER_ERROR_CURRENT_TIME": "The start time must be before the current time.",
  "TIGER_ERROR_DATA_SERVER": "Could not contact local data server daemon. Please restart the user interface",
  "TIGER_ERROR_DEADBAND": "The deadband value is invalid. The deadband must be greater than or equal to zero.",
  "TIGER_ERROR_DISTRIB_DEAD": "The data distribution process is not responding. Please restart the user interface",
  "TIGER_ERROR_DISTRIB_TITLE": "History Distribution Error",
  "TIGER_ERROR_DOWNLOAD_OPT": "You must select at least one of the Data to Download option",
  "TIGER_ERROR_END_INV": "The end time is invalid.",
  "TIGER_ERROR_END_LOAD": "The end time needs to be lower or equal to the end time of the data loaded",
  "TIGER_ERROR_GRAPH_CLIP": "Copying of the graph to clipboard failed.",
  "TIGER_ERROR_GRAPH_SAVE": "Saving of the graph to file failed.",
  "TIGER_ERROR_GRAPH_SAVE_TITLE": "Save Graph Error",
  "TIGER_ERROR_INVALID_DATA": "Invalid data file : %s",
  "TIGER_ERROR_LICENSE_MSG": "License error for system ID: %s, %s",
  "TIGER_ERROR_LICENSE_TITLE": "Tiger License Error",
  "TIGER_ERROR_LIMIT": "The high limit value must be greater than or equal to the low limit value.",
  "TIGER_ERROR_LIMIT_HIGHINV": "The high limit value is invalid",
  "TIGER_ERROR_LIMIT_LOWINV": "The low limit value is invalid",
  "TIGER_ERROR_LOAD_TIME": "The end time must be no more than %d hours after the start time.",
  "TIGER_ERROR_MULTI_REPLAY": "Can't replay file from different turbines at the same time",
  "TIGER_ERROR_NOT_RUNNING": "Tiger for turbine %s is not responding. Please restart the user interface",
  "TIGER_ERROR_NO_TURBINE": "No turbine associated with the %s has been started",
  "TIGER_ERROR_PRINTER_COPY": "Tiger could not copy to the printer.",
  "TIGER_ERROR_PRINTER_DIAG": "Tiger could not print the diagnostics.",
  "TIGER_ERROR_PRINTER_GRAPH": "Printing of the graph failed.",
  "TIGER_ERROR_REMOTE_MANUAL": "Remote Manual not found",
  "TIGER_ERROR_REPORT_ENTRY": "Can't find report entry: %s in section: %s",
  "TIGER_ERROR_REPORT_FAILED": "Generation of report file: %s failed",
  "TIGER_ERROR_REPORT_GRAPH_FAILED": "Failed to replace graph report with id: %s",
  "TIGER_ERROR_REPORT_FILE": "Can't find report file: %s",
  "TIGER_ERROR_REPORT_TITLE": "Tiger Report Error",
  "TIGER_ERROR_SAMPLERATE": "Sample Rate needs to be greater or equal to 1 second ",
  "TIGER_ERROR_SISTEMI_MANUAL": "Systemi Ausiliari Manual not found",
  "TIGER_ERROR_START_DATE": "The end date must be greater or equal to the start date.",
  "TIGER_ERROR_START_INV": "The start time is invalid.",
  "TIGER_ERROR_START_LOAD": "The start time needs to be greater or equal to the start time of the data loaded",
  "TIGER_ERROR_START_TIME": "The end time must be greater or equal to the start time.",
  "TIGER_ERROR_TREND_RESP": "Historical Trend for turbine %s is not responding. Please try again later...",
  "TIGER_ERROR_TURBINE_MANUAL": "Turbine Manuals not found",
  "TIGER_ERROR_TURBOGAS_MANUAL": "Turbogas Manual not found",
  "TIGER_ERROR_USER_MANUAL": "User Manual not found",
  "TIGER_ERROR_VAL_TITLE": "Tiger Validation Error",
  "TIGER_ERROR_X_VALUE": "The maximum X value must be greater or equal to the minimum X value",
  "TIGER_ERROR_Y_VALUE": "The maximum Y value must be greater or equal to the minimum Y value",
  "TIGER_EVENT_PROC": "Event model process is not running",
  "TIGER_EVENT_TITLE": "Event Report for %s for turbine %s at %s",
  "TIGER_EXIT_PASSWORD": "Please enter the password",
  "TIGER_EXIT_TITLE": "Exit Tiger",
  "TIGER_EXPORT_BIN_TITLE": "Exporting of Tiger Data",
  "TIGER_EXPORT_BINARY": "Binary Export Options",
  "TIGER_EXPORT_CHANNEL": "Export Channel Selection",
  "TIGER_EXPORT_CHANNEL_DESCR": "Channel Description",
  "TIGER_EXPORT_CHANNEL_NAME": "Channel Name",
  "TIGER_EXPORT_OPTIONS": "Export Options",
  "TIGER_EXPORT_PROGRESS_MSG": "Exporting data from %s to %s",
  "TIGER_EXPORT_PROGRESS_TITLE": "Exporting Data Progress : ",
  "TIGER_EXPORT_SAMPLE": "Sample Interval",
  "TIGER_EXPORT_SAVE_TITLE": "Save Export File As",
  "TIGER_EXPORT_SETS": "Sets ...",
  "TIGER_EXPORT_SETS_TITLE": "Export Sets for turbine ",
  "TIGER_EXPORT_SET_LOAD": "Load/Remove Selected Set",
  "TIGER_EXPORT_SET_SAVE": "Save Current Set",
  "TIGER_EXPORT_SUCCESS_MSG": "Successfully exported data to file: %s\n\nDo you want to open this file ?",
  "TIGER_EXPORT_TIME": "Export Time Selection",
  "TIGER_EXPORT_TREND_TITLE": "Exporting of Tiger Trend Data",
  "TIGER_EXPORT_VAL_MULTI": "Sample Rate must be a multiplier of %s",
  "TIGER_EXPORT_VAL_TITLE": "Validation Error",
  "TIGER_GRAPH_ACTIVE_TITLE": "Diagnostics Active Time Graph for ",
  "TIGER_GRAPH_ARIMA_TITLE": "Arima Graph for",
  "TIGER_GRAPH_CHANNEL_ALL": "All",
  "TIGER_GRAPH_CHANNEL_ANALOG": "Analogue",
  "TIGER_GRAPH_CHANNEL_DIGITAL": "Digital",
  "TIGER_GRAPH_CHANNEL_EXPORT_TITLE": "Exporting of Data",
  "TIGER_GRAPH_CHANNEL_GRAPH_TITLE": "Graph Channel Selection",
  "TIGER_GRAPH_CHANNEL_HIST_GRAPH_TITLE": "Historical Graph Channel Selection",
  "TIGER_GRAPH_CHANNEL_IMPORT_ADD": "Select",
  "TIGER_GRAPH_CHANNEL_IMPORT_TITLE": "Importing of Data",
  "TIGER_GRAPH_CHANNEL_MODEL": "Model",
  "TIGER_GRAPH_CHANNEL_MULTI_TERROR": "Time Error",
  "TIGER_GRAPH_CHANNEL_MULTI_TITLE": "Multi-time Graph Channel Selection",
  "TIGER_GRAPH_CHANNEL_REPLACE": "Replace",
  "TIGER_GRAPH_CHANNEL_SPECTRUM": "Spectrum",
  "TIGER_GRAPH_CHANNEL_X_CHANNEL": "X Channel",
  "TIGER_GRAPH_COLOUR": "Change %s colour",
  "TIGER_GRAPH_COPY_TITLE": "Copy Graph Error",
  "TIGER_GRAPH_DESCR": "Description",
  "TIGER_GRAPH_DISTRIB_ADD": "Add",
  "TIGER_GRAPH_DISTRIB_CFACT": "Confidence Factor",
  "TIGER_GRAPH_DISTRIB_CHIGH": "Calculated High",
  "TIGER_GRAPH_DISTRIB_CLOW": "Calculated Low",
  "TIGER_GRAPH_DISTRIB_CVAR": "Variation",
  "TIGER_GRAPH_DISTRIB_DDB": "Deadband",
  "TIGER_GRAPH_DISTRIB_DEL": "Delete",
  "TIGER_GRAPH_DISTRIB_DHIGH": "Diagnostic High",
  "TIGER_GRAPH_DISTRIB_DLOW": "Diagnostic Low",
  "TIGER_GRAPH_DISTRIB_DMSG": "Message",
  "TIGER_GRAPH_DISTRIB_DORG": "Origin",
  "TIGER_GRAPH_DISTRIB_DTITLE": "Diagnostics Display",
  "TIGER_GRAPH_DISTRIB_STITLE": "Statistical Display",
  "TIGER_GRAPH_DISTRIB_TITLE": "Distribution Graph ",
  "TIGER_GRAPH_DISTRIB_UPD": "Update",
  "TIGER_GRAPH_DRAW_FIRST": "Draw %s First",
  "TIGER_GRAPH_EVENT": "Event",
  "TIGER_GRAPH_EVENT_SCALE": "Event Scale",
  "TIGER_GRAPH_EVENT_TITLE": "Event Model Graph ",
  "TIGER_GRAPH_EXPORT_TITLE": "Save Export File As",
  "TIGER_GRAPH_FOR": "For ",
  "TIGER_GRAPH_FREEZE": "Freeze Graph",
  "TIGER_GRAPH_FREQ": "Freq of max",
  "TIGER_GRAPH_FROM_SET": "From Set ",
  "TIGER_GRAPH_HIGH": "High",
  "TIGER_GRAPH_HISTDISTRIB_TITLE": "Historical Distribution Graph ",
  "TIGER_GRAPH_HISTTREND_TITLE": "Historical Trend Graph ",
  "TIGER_GRAPH_LEGEND": "Legend",
  "TIGER_GRAPH_LIMIT_DB": "Deadband",
  "TIGER_GRAPH_LIMIT_EXT": "There is already a limit set for %s with origin %s.",
  "TIGER_GRAPH_LIMIT_HIGH": "Diagnostic High",
  "TIGER_GRAPH_LIMIT_LOW": "Diagnostic Low",
  "TIGER_GRAPH_LIMIT_MSG": "Message",
  "TIGER_GRAPH_LIMIT_ORG": "Origin",
  "TIGER_GRAPH_LIMIT_TITLE": "Diagnostics Display",
  "TIGER_GRAPH_LOADING": "Loading Data ...",
  "TIGER_GRAPH_LOCK": "Lock Cursor",
  "TIGER_GRAPH_LOW": "Low",
  "TIGER_GRAPH_MAX": "Max",
  "TIGER_GRAPH_MEAN": "Mean",
  "TIGER_GRAPH_MIN": "Min",
  "TIGER_GRAPH_MULTI_CUR": "Current",
  "TIGER_GRAPH_MULTI_HIST": "Historical",
  "TIGER_GRAPH_MULTI_TITLE": "Multi-time Graph ",
  "TIGER_GRAPH_MULTI_TRENDXY_TITLE": "Multi-Trend XY Graph ",
  "TIGER_GRAPH_NORMALISED": "(normalised) ",
  "TIGER_GRAPH_NYQUIST_TITLE": "Nyquist Graph",
  "TIGER_GRAPH_ORBIT_TITLE": "Orbit Graph",
  "TIGER_GRAPH_PRINT": "Print",
  "TIGER_GRAPH_PRINT_TITLE": "Printing Error",
  "TIGER_GRAPH_REFRESH": "Refresh",
  "TIGER_GRAPH_REPLAY_FROM": "Replay From %s",
  "TIGER_GRAPH_SAVE_TITLE": "Save Graph File As",
  "TIGER_GRAPH_SPECTRUM_TITLE": "Spectrum Graph ",
  "TIGER_GRAPH_STATE": "State",
  "TIGER_GRAPH_STD": "Std Dev",
  "TIGER_GRAPH_TAGNAME": "Tag Name",
  "TIGER_GRAPH_TARGET_TITLE": "Target Graph",
  "TIGER_GRAPH_TIME": "Time",
  "TIGER_GRAPH_HISTORICAL_TITLE": "Historical Graph ",
  "TIGER_GRAPH_TITLE": "Graph ",
  "TIGER_GRAPH_TMAX": "Time of max",
  "TIGER_GRAPH_TOOLBAR": "Toolbar",
  "TIGER_GRAPH_TRENDXY_TITLE": "Trend XY Graph ",
  "TIGER_GRAPH_TREND_TITLE": "Trend Graph ",
  "TIGER_GRAPH_TURBINE": "Turbine",
  "TIGER_GRAPH_TYPE": "Type",
  "TIGER_GRAPH_VALUE": "Value",
  "TIGER_GRAPH_VALUE_DB": "deadband",
  "TIGER_GRAPH_VALUE_HIGH": "high limit",
  "TIGER_GRAPH_VALUE_INV": "The %s value is invalid.",
  "TIGER_GRAPH_VALUE_LOW": "low limit",
  "TIGER_GRAPH_VALUE_MIS": "The %s value is missing.",
  "TIGER_GRAPH_VALUE_TITLE": "Update Limits Error",
  "TIGER_GRAPH_WATERFALL_TITLE": "Waterfall Graph ",
  "TIGER_GRAPH_XY_SCALE": "Set XY-Scale",
  "TIGER_GRAPH_XY_TITLE": "XY Graph ",
  "TIGER_GRAPH_X_CURSOR": "X Cursor",
  "TIGER_GRAPH_Y_CURSOR": "Y Cursor",
  "TIGER_HIST_TIME_EXISTS": "Use Existing Range",
  "TIGER_HIST_TIME_NEW": "New Time Range",
  "TIGER_HIST_TIME_TITLE": "Historical Graph Time Selection",
  "TIGER_IMPORT_CREATE_NEW": "Create New Data ...",
  "TIGER_IMPORT_CREATE_SUCCESS": "Succesfully created import data from %s to %s",
  "TIGER_IMPORT_DATA_FUNC": "Data Function Value",
  "TIGER_IMPORT_DATA_LOADED": "Data Loaded information",
  "TIGER_IMPORT_DATA_TITLE": "Test Data Creation",
  "TIGER_IMPORT_FAIL": "Failed to load import data file %s",
  "TIGER_IMPORT_FILE": "File",
  "TIGER_IMPORT_FILE_NEW": "Import New Data ...",
  "TIGER_IMPORT_FIXED": "Fixed",
  "TIGER_IMPORT_FOLDER": "Select the directory where the test data will be saved",
  "TIGER_IMPORT_FROM_FILE": "Import from file ...",
  "TIGER_IMPORT_LOAD_TITLE": "Load Import data",
  "TIGER_IMPORT_MODIF_FAIL": "Failed to modify test data for channel %s",
  "TIGER_IMPORT_MODIF_REQ_FAIL": "Failed to send modify test data request",
  "TIGER_IMPORT_MODIF_TITLE": "Modify Test Data",
  "TIGER_IMPORT_OFFSET": "Offset",
  "TIGER_IMPORT_RAMP": "Ramp",
  "TIGER_IMPORT_REQ_FAIL": "Failed to send load import data request",
  "TIGER_IMPORT_SAVE_DATA": "Save Test Data ...",
  "TIGER_IMPORT_SAVE_FAIL": "Failed to save the test data in the directory %s",
  "TIGER_IMPORT_SAVE_REQ_FAIL": "Failed to send save test data request",
  "TIGER_IMPORT_SAVE_SUCCESS": "Test data has been successfully saved in the directory %s",
  "TIGER_IMPORT_SAVE_TITLE": "Save Test Data",
  "TIGER_IMPORT_SELECT_TAG": "Select Tag ...",
  "TIGER_IMPORT_SUCCESS": "Import data file %s has been succesfully loaded",
  "TIGER_IMPORT_TEST_DATA": "Test Data Creation",
  "TIGER_IMPORT_VAL_CHANNEL": " The channel %s is invalid for the turbine %s",
  "TIGER_IMPORT_VAL_DIG": "Only 0 and 1 values are supported for digital tags",
  "TIGER_IMPORT_VAL_TITLE": "Test Data Creation",
  "TIGER_IMPORT_VAL_TYPE": "The type needs to be Fixed for digital tags",
  "TIGER_INIT_MSG": "Initialising Tiger for site %s\nPlease wait...",
  "TIGER_INSERT_CDROM": "Please select the location of the data for the turbine %s from %s to %s",
  "TIGER_LIMIT_LOW_ALARM": "Tiger Low Limit Value: %.2f ",
  "TIGER_LIMIT_HIGH_ALARM": "Tiger High Limit Value: %.2f ",
  "TIGER_LOADING_REMOTE": "Please wait\nLoading Remote Manual",
  "TIGER_LOADING_REPORT": "Please wait\nLoading Report Reader",
  "TIGER_LOADING_TITLE": "Loading",
  "TIGER_LOADING_TURBINE": "Please wait\nLoading Turbine Manuals",
  "TIGER_LOADING_USER": "Please wait\nLoading User Manual",
  "TIGER_LOAD_BINARY_TITLE": "Load Tiger binary data",
  "TIGER_LOAD_TREND_TITLE": "Load Tiger trend data",
  "TIGER_NEW_DIAG_DEAD": "Deadband",
  "TIGER_NEW_DIAG_HIGH": "High Limit",
  "TIGER_NEW_DIAG_LOW": "Low Limit",
  "TIGER_NEW_DIAG_MESID": "Message ID",
  "TIGER_NEW_DIAG_ORIG": "Origin",
  "TIGER_NEW_DIAG_TITLE": "Add Diagnostics Limit",
  "TIGER_NOX_DATA": "NOX Emission data is not available",
  "TIGER_OPC_ALARM": "OPC Alarms",
  "TIGER_OPC_ALARMS": "Alarms",
  "TIGER_OPC_EVENTS": "Events",
  "TIGER_PASSWORD_INVALID": "Password is invalid",
  "TIGER_PASSWORD_TITLE": "Password Error",
  "TIGER_PERF": "Performance",
  "TIGER_PERF_ALLOW": "Allowable",
  "TIGER_PERF_ANALYSIS": "Current performance analysis window : %d out of %d",
  "TIGER_PERF_COMP": "Compressor(%)",
  "TIGER_PERF_CURRENT": "Current Performance",
  "TIGER_PERF_DEV": "Current deviation from average",
  "TIGER_PERF_DEVIATION": "Deviation",
  "TIGER_PERF_HEAT": "Heat",
  "TIGER_PERF_INLET": "Inlet Temp",
  "TIGER_PERF_NOTBASE": "Turbine is not Running on Base Load",
  "TIGER_PERF_POWER": "Power(MW)",
  "TIGER_PERF_PROC": "Performance process is not running",
  "TIGER_PERF_RED": "(a red value indicates that the turbine is not stable enough to measure performance)",
  "TIGER_PERF_TAGNAME": "Tag Name",
  "TIGER_PERF_TEXT": "................",
  "TIGER_PERF_TITLE": "Performance Stability Report for turbine %s at %s",
  "TIGER_PERF_VIEW": "To view the stability report, please first load data for the time required",
  "TIGER_PERF_WINDOW": "Number of 4 minute windows used to produce the current performance figures: %d",
  "TIGER_PI_ALARM": "PI Alarms",
  "TIGER_PLEASE_WAIT": "Please Wait ...",
  "TIGER_PRINTER_TITLE": "Printer Error",
  "TIGER_PROCESSING": "Processing : ",
  "TIGER_QUERY_ALARM": "Speedtronic Alarms",
  "TIGER_QUERY_ALARM_DALARM": "DALARM",
  "TIGER_QUERY_ALARM_EVT": "EVENT",
  "TIGER_QUERY_ALARM_PALARM": "PALARM",
  "TIGER_QUERY_APPLY_LATER": "Apply Later",
  "TIGER_QUERY_APPLY_NOW": "Apply Now",
  "TIGER_QUERY_FAILED_SENSOR": "Show only Failed Sensors",
  "TIGER_QUERY_FILTER": "FILTER",
  "TIGER_QUERY_FILTER_INV": "Inverse",
  "TIGER_QUERY_FILTER_OFF": "Off",
  "TIGER_QUERY_FILTER_ON": "On",
  "TIGER_QUERY_GROUP": "Group results per turbine",
  "TIGER_QUERY_HIST_TITLE": "Run Historical Query",
  "TIGER_QUERY_LATCH": "Latch Count",
  "TIGER_QUERY_MES_AREA": "Message Area",
  "TIGER_QUERY_MES_ID": "Message Id",
  "TIGER_QUERY_MES_TXT": "Message Text",
  "TIGER_QUERY_PROGRESS_MSG": "Query from %s to %s",
  "TIGER_QUERY_PROGRESS_TITLE": "Query Progress : ",
  "TIGER_QUERY_SEVERITY": "Severity",
  "TIGER_QUERY_SEV_CRIT": "Critical",
  "TIGER_QUERY_SEV_EVT": "Event",
  "TIGER_QUERY_SEV_FAULT": "Fault",
  "TIGER_QUERY_SEV_INFO": "Information",
  "TIGER_QUERY_SEV_TRIP": "Trip",
  "TIGER_QUERY_SEV_WARN": "Warning",
  "TIGER_QUERY_TIME": "Time Selection",
  "TIGER_QUERY_TYPE": "Type",
  "TIGER_QUERY_TYPE_AREA": "Group results per Area",
  "TIGER_QUERY_TYPE_AREA_OCC": "Area by Occurrences",
  "TIGER_QUERY_TYPE_COMP": "Complete Listing",
  "TIGER_QUERY_TYPE_CURR": "Currently Abnormal",
  "TIGER_QUERY_TYPE_DCS": "DCS Alarm",
  "TIGER_QUERY_TYPE_DIAG": "Diagnostics List",
  "TIGER_QUERY_TYPE_INVALID": "Disabled",
  "TIGER_QUERY_TYPE_OCCUR": "Number of Occurrences",
  "TIGER_QUERY_TYPE_TOP": "Top Level",
  "TIGER_RAS_ALLDEVICECONNECTED": "All Devices Connected",
  "TIGER_RAS_AUTHENTICATE": "Verifying username and password",
  "TIGER_RAS_CONNECTDEVICE": "Dialing",
  "TIGER_RAS_CONNECTED": "Connected",
  "TIGER_RAS_DEVICECONNECTED": "Device Connected",
  "TIGER_RAS_DISCONNECTED": "Disconnected",
  "TIGER_RAS_ERROR_DLG": "RasDialDlg failed: Error = %d\n",
  "TIGER_RAS_ERROR_ENUM": "Undefined RasEnumConnections Error (%ld).",
  "TIGER_RAS_ERROR_GETENTRY": "Undefined RasGetEntryDialParams Error (%ld).",
  "TIGER_RAS_ERROR_TITLE": "Dial Up Connection Error",
  "TIGER_RAS_ERROR_UNDEF": "Undefined RAS Dial Error (%ld).",
  "TIGER_RAS_OPENPORT": "Opening Port",
  "TIGER_RAS_PORTOPENED": "Port Opened",
  "TIGER_RELOAD_DIAG_FAIL": "Reload of diagnostics failed",
  "TIGER_RELOAD_DIAG_SUCCESS": "Reload of diagnostics succeeded",
  "TIGER_RELOAD_DIAG_TITLE": "Reload Diagnostics",
  "TIGER_RELOAD_MSG": "This will reload the diagnotics for turbine: %s",
  "TIGER_RELOAD_TITLE": "Reload Diagnostics",
  "TIGER_REPLAY_CANCEL_MSG": " This will stop and cancel the current replay of data for : ",
  "TIGER_REPLAY_CANCEL_TITLE": "Stop Replay : ",
  "TIGER_REPLAY_DATA_REQ": "Replay Data",
  "TIGER_REPLAY_END_TIME": "Enter the time to end replay",
  "TIGER_REPLAY_FILE_MSG": "Please wait...\nLoading data for %s\n from file %s",
  "TIGER_REPLAY_MODEL_MSG": "Please wait...\nLoading Model data for %s for %s",
  "TIGER_REPLAY_MULTI_MSG": "Please wait...\nLoading data for %s\n from multiple files",
  "TIGER_REPLAY_NEXT": "Replay Next Data",
  "TIGER_REPLAY_PREV": "Replay Previous Data",
  "TIGER_REPLAY_START_TIME": "Enter the time to start replay from",
  "TIGER_REPLAY_TIME_MSG": "Please wait...\nLoading data for %s\n from %s to %s",
  "TIGER_REPLAY_TITLE": "Replay Progress: %s",
  "TIGER_REPORT_PROGRESS": "Please wait...\n\nGenerating Tiger Report File",
  "TIGER_REPORT_MONTH_LABEL": "Please enter the month you want to generate this report for",
  "TIGER_REPORT_MONTH_TITLE": "Report Month Selection",
  "TIGER_REPORT_SUCCESS_MSG": "Successfully generated report file: %s\n\nDo you want to open this report",
  "TIGER_REPORT_SUCCESS_TITLE": "Report Generation",
  "TIGER_REPORT_TIME_TITLE": "Tiger Time Report",
  "TIGER_REPORT_YEAR_LABEL": "Please enter the year you want to generate this report for",
  "TIGER_REPORT_YEAR_TITLE": "Report Year Selection",
  "TIGER_RESTART_MSG": "The Tiger configuration has been updated. Please restart the user interface. \n\nPress OK to restart the Tiger user interface now.",
  "TIGER_RESTART_TITLE": "Restart  Tiger",
  "TIGER_RESTORE_DATA_TITLE": "Restore Tiger Data",
  "TIGER_RESTORE_DATA_LOCATION": "Select the location of the backup of the data",
  "TIGER_RESTORE_FAIL": "Tiger restore failed",
  "TIGER_RESTORE_PROGRESS_MSG": "Restoring data from %s to %s",
  "TIGER_RESTORE_SUCCESS": "Tiger restore succeeded",
  "TIGER_RESTORE_NO_DATA": "Tiger restore failed. No data found",
  "TIGER_RES_ACK": "Acknowledge",
  "TIGER_RES_ADD": "Add",
  "TIGER_RES_ADD_ALL": "Add All",
  "TIGER_RES_ADD_X": "Add X",
  "TIGER_RES_ADD_Y": "Add Y",
  "TIGER_RES_APPLY": "Apply",
  "TIGER_RES_APPLY_ALL": "Apply All",
  "TIGER_RES_AVERAGE": "Average Value",
  "TIGER_RES_BROWSE": "Browse",
  "TIGER_RES_CANCEL": "Cancel",
  "TIGER_RES_CANCEL_ALL": "Cancel All",
  "TIGER_RES_CLEAR": "Clear",
  "TIGER_RES_CLOSE": "Close",
  "TIGER_RES_CLOSE_ALL": "Close All",
  "TIGER_RES_CURRENT": "Current Value",
  "TIGER_RES_DOWNLOAD": "Download",
  "TIGER_RES_DURATION": "Duration",
  "TIGER_RES_SERIAL": "Serial",
  "TIGER_RES_END_DATE": "End Date",
  "TIGER_RES_END_TIME": "End Time",
  "TIGER_RES_LOAD": "Load",
  "TIGER_RES_MAX": "Max Value",
  "TIGER_RES_MIN": "Min Value",
  "TIGER_RES_MISSING_ASK": "Ask Me",
  "TIGER_RES_MISSING_DATA": "Missing Data",
  "TIGER_RES_MISSING_DOWN": "Don't ask me. Download all",
  "TIGER_RES_MISSING_SKIP": "Don't ask me. Skip all",
  "TIGER_RES_NO": "No",
  "TIGER_RES_OK": "OK",
  "TIGER_RES_ONLINE": "Live",
  "TIGER_RES_REMOTE": "Live",
  "TIGER_RES_REMOVE": "Remove",
  "TIGER_RES_REPLAY": "Replay",
  "TIGER_RES_RETRY": "Retry",
  "TIGER_RES_SAMPLE_RATE": "Sample Rate",
  "TIGER_RES_SAVE": "Save",
  "TIGER_RES_SKIP": "Skip",
  "TIGER_RES_START_DATE": "Start Date",
  "TIGER_RES_START_TIME": "Start Time",
  "TIGER_RES_SURE": "Are You Sure ?",
  "TIGER_RES_TURBINE": "Turbine",
  "TIGER_RES_TURBINE_STATE": "Turbine State",
  "TIGER_RES_YES": "Yes",
  "TIGER_SAVE_BITMAP_TITLE": "Save Bitmap File As",
  "TIGER_SAVE_REPORT_TITLE": "Save Report File As",
  "TIGER_SENTINEL_ALARM": "Sentinel Alarms",
  "TIGER_SENT_ALARMS": "Alarms",
  "TIGER_SENT_TRIPS": "Trips",
  "TIGER_SERVER_MSG": "Please wait...\n Connecting to Replay Server ",
  "TIGER_SERVER_TITLE": "Replay Server",
  "TIGER_SOUND_TITLE": "Audio Alarm",
  "TIGER_START_REPLAY_MSG": "Please wait...\n Starting analysis for %s data",
  "TIGER_SYSTEM_TIME_MSG": "Enter the System Time",
  "TIGER_SYSTEM_TIME_TITLE": "Setting the System Time",
  "TIGER_TB_ABOUT": "About",
  "TIGER_TB_ADD_CHAN": "Add Channel",
  "TIGER_TB_AUTO_SCALE": "Auto Y Scale",
  "TIGER_TB_CONTINUE": "Continue Replay",
  "TIGER_TB_COPY": "Copy to Clipboard",
  "TIGER_TB_EXPORT": "Export to Text File",
  "TIGER_TB_FIND_NEXT": "Find Next",
  "TIGER_TB_FIND_PREV": "Find Previous",
  "TIGER_TB_FREEZE": "Freeze Updates",
  "TIGER_TB_JUMP_BACK": "Jump Backward",
  "TIGER_TB_JUMP_FORWARD": "Jump Forward",
  "TIGER_TB_LEGEND": "Show Legend",
  "TIGER_TB_LOAD_NEXT": "Load Next",
  "TIGER_TB_LOAD_PREV": "Load Previous",
  "TIGER_TB_MANUAL_SCALE": "Manual Y Scale",
  "TIGER_TB_MAXY_EDIT": "Y Scale Maximum",
  "TIGER_TB_MINY_EDIT": "Y Scale Minimum",
  "TIGER_TB_NEXT_CHAN": "Next Channel",
  "TIGER_TB_NEXT_STATE": "Next Turbine State",
  "TIGER_TB_NORM_SCALE": "Normalised Y Scale",
  "TIGER_TB_PAUSE": "Pause Replay",
  "TIGER_TB_PREV_CHAN": "Previous Channel",
  "TIGER_TB_PREV_STATE": "Previous Turbine State",
  "TIGER_TB_PRINT": "Print",
  "TIGER_TB_PRINT_HISTSCR": "Print Historical Screens",
  "TIGER_TB_PROPERTIES": "Show Properties",
  "TIGER_TB_RATE_DECREASE": "Decrease Rate",
  "TIGER_TB_RATE_INCREASE": "Increase Rate",
  "TIGER_TB_RATE_RESET": "Reset Rate",
  "TIGER_TB_REFRESH": "Refresh",
  "TIGER_TB_REMOVE_CHAN": "Remove Channel",
  "TIGER_TB_RESET_3D_GRAPH": "Reset Graph View",
  "TIGER_TB_SAVE": "Save to File",
  "TIGER_TB_SELECT_TIME": "Set",
  "TIGER_TB_SET_QUERY_ID": "Specify Query",
  "TIGER_TB_SHOW_AS_XY": "Plot Graphs Against Speed",
  "TIGER_TB_SHOW_CALCED_LIMITS": "Show Calculated Limits",
  "TIGER_TB_SHOW_DIAG_LIMITS": "Show Diagnostics Limits",
  "TIGER_TB_SHOW_LIMITS_DISPLAY": "Show Limits Display",
  "TIGER_TB_SHOW_MSG_ID": "Show Message ID",
  "TIGER_TB_START": "Start Replay",
  "TIGER_TB_STEP": "Step Replay",
  "TIGER_TB_STOP": "Stop Replay",
  "TIGER_TB_X_CURSOR_VISIBLE": "Show X Cursor",
  "TIGER_TB_X_SCALE_RESET": "Reset X Scale",
  "TIGER_TB_Y_CURSOR_VISIBLE": "Show Y Cursor",
  "TIGER_TB_ZOOM_IN": "Zoom In",
  "TIGER_TB_ZOOM_OUT": "Zoom Out",
  "TIGER_TDATAREQ_BROWSE": "Select Data location ",
  "TIGER_TDATAREQ_DATA_CDROM": "Please select the location of the data for the turbine %s from %s to %s",
  "TIGER_TDATAREQ_DATA_DOWNLOAD": "%s to %s\n from %s",
  "TIGER_TDATAREQ_DATA_TITLE": "Data Request: %s",
  "TIGER_TDATAREQ_DIAG_CDROM": "Please select the location of the data for the turbine %s from %s to %s",
  "TIGER_TDATAREQ_DIAG_DOWNLOAD": "%s to %s\n from %s",
  "TIGER_TDATAREQ_DIAG_TITLE": "Diagnostics Request: %s",
  "TIGER_TDATAREQ_DISTRIB_CDROM": "Please select the location of the data for the turbine %s from %s to %s",
  "TIGER_TDATAREQ_DISTRIB_DOWNLOAD": "%s to %s\n from %s",
  "TIGER_TDATAREQ_DISTRIB_TITLE": "Distribution Request: %s",
  "TIGER_TDATAREQ_DOWNLOAD": "Download %s",
  "TIGER_TDATAREQ_MODEL_CDROM": "Please select the location of the data for the turbine %s for day %s",
  "TIGER_TDATAREQ_MODEL_DOWNLOAD": "%s to %s\n from %s",
  "TIGER_TDATAREQ_MODEL_TITLE": "Model Request: %s",
  "TIGER_TDATAREQ_MSG": "The data from %s to %s for the turbine %s is not available on the default or alternate location.",
  "TIGER_TDATAREQ_PREDICT_TITLE": "Prediction Model Request: %s",
  "TIGER_TDATAREQ_SKIP_TO": "Skip to %s",
  "TIGER_TDATAREQ_TREND_CDROM": "Please select the location of the data for the turbine %s from %s to %s",
  "TIGER_TDATAREQ_TREND_DOWNLOAD": "%s to %s\n from %s",
  "TIGER_TDATAREQ_TREND_TITLE": "Trend Request: %s",
  "TIGER_THUMB_GRAPH": "Graphs",
  "TIGER_THUMB_HIST_TREND": "Historical Trends",
  "TIGER_THUMB_TREND": "Trends",
  "TIGER_TITLE": "%s: Tiger Knowledge Based Gas Turbine Condition Monitoring - Chromalloy Turbine Services",
  "TIGER_TOOLBAR_REPLAY": "Tiger Replay",
  "TIGER_TOOLSETS_DEFAULT": "Can't overwrite default tool set",
  "TIGER_TOOLSETS_EXPORT": "Export ...",
  "TIGER_TOOLSETS_IMPORT": "Import ...",
  "TIGER_TOOLSETS_TITLE": "Tool Sets",
  "TIGER_TOOLSETS_WIN": "Tool Set Windows",
  "TIGER_TREND_CUSTOM_SELECT": "Select an existing trend for turbine",
  "TIGER_TREND_CUSTOM_TITLE": "Custom Trend Selection",
  "TIGER_TREND_DATA_ALL": "Create trend for all the turbine states",
  "TIGER_TREND_DATA_REQ": "Trend Data Request",
  "TIGER_TREND_DATE_DEFAULT": "Use default historical trend Range",
  "TIGER_TREND_DATE_EXIST": "Use Existing Range",
  "TIGER_TREND_DATE_NEW": "New Date Range",
  "TIGER_TREND_DATE_TITLE": "Trend Date Selection",
  "TIGER_TREND_DAY_MSG": "Please wait...\n Loading trend data for %s\n for day %s",
  "TIGER_TREND_FILE_MSG": "Please wait...\nLoading trend data for %s\n from file %s",
  "TIGER_TREND_FOLDER": "Select the directory where the trend data will be saved",
  "TIGER_TREND_PROGRESS_MSG": "Trend from %s to %s",
  "TIGER_TREND_PROGRESS_TITLE": "Trend Progress : ",
  "TIGER_TREND_REQ_MSG": "Please wait...\n Searching trend data for %s\n from %s to %s",
  "TIGER_TREND_TIME_MSG": "Please wait...\n Loading trend data for %s\n from %s to %s",
  "TIGER_TREND_TITLE": "Trend Progress: %s",
  "TIGER_UNDEFINED": "Undefined",
  "TIGER_VERSION_BIN": "Tiger has detected that the executables on the server are more recent than the ones currently installed on your machine.\n Do you want to download the latest executables from the server.\n\n",
  "TIGER_VERSION_CERTS": "Tiger has detected that the certificates on the server are more recent than the one currently installed on your machine.\n Do you want to download the latest certificates from the server.\n\n",
  "TIGER_VERSION_CONF": "Tiger has detected that the config on the server is more recent than the one currently installed on your machine.\n Do you want to download the latest configuration from the server.\n\n",
  "TIGER_VERSION_CONFVIEWS": "Tiger has detected that the config and views on the server are more recent than the one currently installed on your machine.\n Do you want to download the latest configuration from the server.\n\n",
  "TIGER_VERSION_CUR": ": current version = ",
  "TIGER_VERSION_MANUAL": "Tiger has detected that the manual on the server are more recent than the one currently installed on your machine.\n Do you want to download the latest manual from the server.\n\n",
  "TIGER_VERSION_MSG_BIN": "Bin",
  "TIGER_VERSION_MSG_CERTS": "Certificates",
  "TIGER_VERSION_MSG_CONF": "Config",
  "TIGER_VERSION_MSG_MANUAL": "Manual",
  "TIGER_VERSION_MSG_VIEWS": "Views",
  "TIGER_VERSION_SER": " server version = ",
  "TIGER_VERSION_TITLE": "New Version for %s",
  "TIGER_VERSION_UNK": "<Unknown>",
  "TIGER_VERSION_VIEWS": "Tiger has detected that the views on the server are more recent than the one currently installed on your machine.\n Do you want to download the latest configuration from the server.\n\n",
  "TIGER_WIDGET_DIFF": "Difference between %s and %s",
  "TIGER_WIDGET_FACTORED_DATE": "Predicted Factored Date",
  "TIGER_WIDGET_FACTORED_START": "Predicted Factored Starts",
  "TIGER_WIDGET_OVER_DATE": "Last Overhaul Date",
  "TIGER_WIDGET_REMAIN_HOUR": "Predicted Remaining Hours",
  "TIGER_WIDGET_REMAIN_PEAK": "Remaining Peak Hours",
  "TIGER_WIDGET_SCHEDULE_DATE": "Schedule Date",
  "TIGER_WIDGET_STATUS_OFFLINE": "Replay ",
  "TIGER_WIDGET_STATUS_ONLINE": " Live ",
  "TIGER_WIDGET_STATUS_REMOTE": " Live ",
  "TIGER_WIDGET_TARGET_DATE": "Maintenance Target Date",
  "TIGER_XL_ADDRESS": "Address for Excel",
  "TIGER_XL_BAD_RANGE": "The end must be after the start.",
  "TIGER_XL_CONFIG": "Turbine",
  "TIGER_XL_FORMAT": "Format",
  "TIGER_XL_FROM": "From",
  "TIGER_XL_INTRO": "Pick the data, copy the address, then in Excel use Data > Get Data > From Web and paste it. When Excel asks how to sign in, choose Basic: your user name, with an access token as the password.",
  "TIGER_XL_KIND": "Data",
  "TIGER_XL_KIND_BINARY": "Binary",
  "TIGER_XL_KIND_CURRENT": "Current values",
  "TIGER_XL_KIND_TREND": "Trend",
  "TIGER_XL_LONG_RANGE": "Binary data is limited to 31 days per request.",
  "TIGER_XL_MORE": "%s more: refine the search",
  "TIGER_XL_NEED": "Choose a turbine and at least one tag.",
  "TIGER_XL_NONE_SELECTED": "No tags selected yet.",
  "TIGER_XL_NO_TOKEN_NEEDED": "Sign-in is off on this site, so choose Anonymous instead.",
  "TIGER_XL_PQ": "Power Query (Advanced Editor)",
  "TIGER_XL_PQ_HINT": "Or paste this into a Blank Query's Advanced Editor. It also sets the column types, so numbers read correctly whatever Excel's decimal separator.",
  "TIGER_XL_RANGE": "Time range",
  "TIGER_XL_RANGE_FIXED": "From / to",
  "TIGER_XL_RANGE_LIVE": "Live buffer",
  "TIGER_XL_REMOVE": "Remove",
  "TIGER_XL_SEARCH": "Search tags or descriptions",
  "TIGER_XL_SELECTED": "Selected, in column order",
  "TIGER_XL_STEP": "One row every N seconds (optional)",
  "TIGER_XL_TAGS": "Tags",
  "TIGER_XL_TEST": "Test",
  "TIGER_XL_TESTING": "Testing...",
  "TIGER_XL_TEST_ROWS": "%s rows; the first ones are shown",
  "TIGER_XL_TITLE": "Excel Data Query",
  "TIGER_XL_TO": "To",
  "TIGER_XL_TOKEN_LINK": "Create an access token",
  "TIGER_XYSCALE_TITLE": "X-Y Scale Settings",
  "TIGER_XYSCALE_MINX": "Minimum X",
  "TIGER_XYSCALE_MAXX": "Maximum X",
  "TIGER_XYSCALE_MINY": "Minimum Y",
  "TIGER_XYSCALE_MAXY": "Maximum Y",
  "TIGER_HIST_TREND_PROGRESS_TITLE": "Building Historical Trend",
  "TIGER_DIAG_PROGRESS_TITLE": "Processing Diagnostics",
  "TIGER_TB_BIG_STEP_BACK": "Big Step Back",
  "TIGER_TB_BIG_STEP_FORWARD": "Big Step Forward",
  "TIGER_TB_SMALL_STEP_BACK": "Small Step Back",
  "TIGER_TB_SMALL_STEP_FORWARD": "Small Step Forward",
  "TIGERUI_DIAG_CLEAR_MESSAGES": "Clear Diagnostics Messages",
  "TIGERUI_DIAG_TOGGLE_MESSAGES": "Show/Hide Diagnostics Messages",
  "TIGERUI_IMPORT_CSD": "Import CSD",
  "TIGERUI_THEMES": "Theme",
  "TIGERUI_SELECT_DATA_FILE": "Select Data File...",
  "TIGER_ABOUT_LOGO": "Tiger Logo",
  "TIGER_BACKUP_DESKTOP_ONLY": "Backup is only available in the desktop app.",
  "TIGER_BACKUP_LOCATION_FIELD": "backup location",
  "TIGER_DIAG_EMPTY_QUERY_HINT": "Click %s to query diagnostics.",
  "TIGER_DIAG_ERROR_PREFIX": "Error: %s",
  "TIGER_DIAG_MESSAGES_PANEL": "Diagnostics messages",
  "TIGER_DIAG_NO_MESSAGES": "No diagnostics messages",
  "TIGER_DIAG_RESIZE_MESSAGES": "Drag to resize (double-click to reset)",
  "TIGER_DIAG_ORPHANS_COUNT": "Orphans (%s)",
  "TIGER_DIAG_OTHER_FAULTS_AREA": "Other faults present in area",
  "TIGER_DIAG_REPORT_TITLE_CURRENT": "%s Current Diagnostics",
  "TIGER_DIAG_REPORT_TITLE_HIST": "%s Historical Diagnostics",
  "TIGER_DIAG_SAVE_FILTER_DOC": "Office Diagnostics File",
  "TIGER_DIAG_SAVE_FILTER_FODT": "LibreOffice Template Diagnostics File",
  "TIGER_DIAG_SAVE_FILTER_ODT": "LibreOffice Diagnostics File",
  "TIGER_DIAG_SAVE_FILTER_PDF": "PDF Diagnostics File",
  "TIGER_DIAG_SAVE_FILTER_TXT": "Text Diagnostics File",
  "TIGER_DIAG_SAVE_FILTER_XML": "Office Template Diagnostics File",
  "TIGER_DIAG_SEARCH_MATCH": "%s match",
  "TIGER_DIAG_SEARCH_MATCHES": "%s matches",
  "TIGER_DIAG_SEARCH_MESSAGES": "Search messages...",
  "TIGER_DOWNLOAD_CANCELLING": "Cancelling...",
  "TIGER_DOWNLOAD_CANCEL_TOOLTIP": "Cancel download",
  "TIGER_DOWNLOAD_DOWNLOADING": "Downloading ",
  "TIGER_DOWNLOAD_DOWNLOADING_DATA": "Downloading data for ",
  "TIGER_DOWNLOAD_ESTIMATING": "estimating...",
  "TIGER_DOWNLOAD_ETA_LEFT": "%s left",
  "TIGER_EXPORT_ADD": "Add...",
  "TIGER_EXPORT_AVERAGE": "Average",
  "TIGER_EXPORT_CANCEL_TOOLTIP": "Cancel export",
  "TIGER_EXPORT_DATA_FOR": "Exporting data for",
  "TIGER_EXPORT_EXPORTING": "Exporting...",
  "TIGER_EXPORT_FAILED": "Export failed: %s",
  "TIGER_EXPORT_FILTER_ALL": "All Files",
  "TIGER_EXPORT_FILTER_EXCEL": "Export Excel File",
  "TIGER_EXPORT_FILTER_TEXT": "Export Text File",
  "TIGER_EXPORT_INVALID_TIME": "Enter a valid start and end date/time.",
  "TIGER_EXPORT_LOGIC": "Logic",
  "TIGER_EXPORT_NO_CHANNELS": "Add at least one channel to export.",
  "TIGER_EXPORT_OPEN_FAILED": "Couldn't open the exported file:\n%s\n\n%s",
  "TIGER_EXPORT_SAMPLE_POSITIVE": "Sample interval must be greater than zero.",
  "TIGER_EXPORT_SELECT_TURBINE": "Select a turbine.",
  "TIGER_EXPORT_SELECT_TURBINE_OPTION": "-- Select Turbine --",
  "TIGER_GRAPH_ADD_PLOT": "Add Plot",
  "TIGER_GRAPH_CHANNEL_CHANNELS": "Channels",
  "TIGER_GRAPH_CHANNEL_EVENT_OCCURRENCES": "Event Occurrences",
  "TIGER_GRAPH_CHANNEL_NONE_SELECTED": "(none selected)",
  "TIGER_GRAPH_CHANNEL_SELECT_TITLE": "Channel Selection",
  "TIGER_GRAPH_CHANNEL_TREND_TITLE": "Trend Channel Selection",
  "TIGER_GRAPH_CHANNEL_XY_TITLE": "XY Graph Channel Selection",
  "TIGER_GRAPH_CHANNEL_Y_CHANNEL": "Y Channel",
  "TIGER_GRAPH_CLICK_CHANGE_PLOT_COLOUR": "Click to change plot colour",
  "TIGER_GRAPH_COPY": "Copy",
  "TIGER_GRAPH_DONE": "Done",
  "TIGER_GRAPH_DRAG_RESIZE_COLUMN": "Drag to resize column",
  "TIGER_GRAPH_EDIT_END_DATE": "Edit end date",
  "TIGER_GRAPH_EDIT_END_TIME": "Edit end time",
  "TIGER_GRAPH_EDIT_START_DATE": "Edit start date",
  "TIGER_GRAPH_EDIT_START_TIME": "Edit start time",
  "TIGER_GRAPH_EXPORT_DATA": "Export Data",
  "TIGER_GRAPH_HEX": "Hex",
  "TIGER_GRAPH_HEX_COLOUR": "Hex colour",
  "TIGER_GRAPH_LOADING_MSG": "Loading...",
  "TIGER_GRAPH_MULTI_TIME_TITLE": "Multi Time Graph",
  "TIGER_GRAPH_NEXT_STATE": "Next State",
  "TIGER_GRAPH_PLOT_PALETTE": "Plot palette",
  "TIGER_GRAPH_PNG_IMAGE": "PNG Image",
  "TIGER_GRAPH_PREV_STATE": "Previous State",
  "TIGER_GRAPH_REMOVE_PLOT": "Remove Plot",
  "TIGER_GRAPH_SAMPLER": "Sampler",
  "TIGER_GRAPH_SAVE_IMAGE": "Save Image",
  "TIGER_GRAPH_SELECT_PLOT_COLOUR": "Select plot colour",
  "TIGER_GRAPH_TRENDMULTIXY_CHANNEL_TITLE": "Trend Multi XY Graph Channel Selection",
  "TIGER_GRAPH_TRENDXY_CHANNEL_TITLE": "Trend XY Graph Channel Selection",
  "TIGER_GRAPH_X_AUTO": "X Auto",
  "TIGER_GRAPH_X_DESCRIPTION": "X Description",
  "TIGER_GRAPH_X_MANUAL": "X Manual",
  "TIGER_GRAPH_X_MAX": "X Max",
  "TIGER_GRAPH_X_MIN": "X Min",
  "TIGER_GRAPH_X_TAG": "X Tag",
  "TIGER_GRAPH_X_VS_Y": "%s vs %s",
  "TIGER_GRAPH_Y_AUTO": "Y Auto",
  "TIGER_GRAPH_Y_DESCRIPTION": "Y Description",
  "TIGER_GRAPH_Y_MANUAL": "Y Manual",
  "TIGER_GRAPH_Y_MAX": "Y Max",
  "TIGER_GRAPH_Y_MIN": "Y Min",
  "TIGER_GRAPH_Y_NORMALIZE": "Y Normalize",
  "TIGER_GRAPH_Y_TAG": "Y Tag",
  "TIGER_LICENSE_ERROR_TITLE": "License Error",
  "TIGER_LICENSE_EXIT": "Exit",
  "TIGER_LOAD_EVENT_TIMES_ERROR": "Failed to load event times",
  "TIGER_LOAD_EVENT_TIMES_FAILED": "Failed to load event times: %s",
  "TIGER_LOAD_EVENT_TIMES_LOADING": "Loading event times...",
  "TIGER_LOAD_INVALID_DATETIME": "Please enter valid start and end dates/times.",
  "TIGER_LOAD_SELECTION": "Selection",
  "TIGER_LOAD_TIME_RANGE": "Time Range",
  "TIGER_LOGIN_AUTH_CODE": "Authenticator code",
  "TIGER_LOGIN_REMEMBER_DEVICE": "Remember this device",
  "TIGER_LOGIN_BACK_TO_SIGN_IN": "Back to sign in",
  "TIGER_LOGIN_CHANGE_PASSWORD_TITLE": "Change Password",
  "TIGER_LOGIN_CHANGE_PWD_OK": "Your password has been changed.",
  "TIGER_LOGIN_CONFIRM_PASSWORD": "Confirm new password",
  "TIGER_LOGIN_CURRENT_PASSWORD": "Current password",
  "TIGER_LOGIN_EMAIL_LINK": "Email Link",
  "TIGER_LOGIN_FORGOT_PASSWORD": "Forgot your password?",
  "TIGER_LOGIN_FORGOT_PROMPT": "Enter your username or email address and we will send you a reset link.",
  "TIGER_LOGIN_FORGOT_SENT": "Please check your email to reset your password.",
  "TIGER_LOGIN_FORGOT_TITLE": "Forgot Your Password?",
  "TIGER_LOGIN_LOGO_ALT": "Tiger",
  "TIGER_LOGIN_MFA_NOTE": "Two-factor verification will be requested if enabled.",
  "TIGER_LOGIN_NEW_PASSWORD": "New password",
  "TIGER_LOGIN_PASSWORD": "Password",
  "TIGER_LOGIN_PWD_MISMATCH": "The password and confirmation password do not match.",
  "TIGER_LOGIN_RESET": "Reset Password",
  "TIGER_LOGIN_RESET_DONE": "Your password has been reset. You can now sign in.",
  "TIGER_LOGIN_RESET_TITLE": "Choose a New Password",
  "TIGER_LOGIN_SAVING": "Saving...",
  "TIGER_LOGIN_SENDING": "Sending...",
  "TIGER_LOGIN_SIGNING_IN": "Signing in...",
  "TIGER_LOGIN_SIGN_IN": "Sign In",
  "TIGER_LOGIN_TITLE": "Tiger Sign In",
  "TIGER_LOGIN_TWO_FACTOR_TITLE": "Two-Factor Verification",
  "TIGER_LOGIN_USERNAME": "Username",
  "TIGER_LOGIN_USERNAME_OR_EMAIL": "Username or email",
  "TIGER_LOGIN_VERIFY": "Verify",
  "TIGER_LOGIN_VERIFYING": "Verifying...",
  "TIGER_QUERY_ALARM_SOURCES": "Alarm Sources",
  "TIGER_QUERY_ALL_STATES": "All States",
  "TIGER_QUERY_ALL_TURBINES": "(All Turbines)",
  "TIGER_REPLAY_LOADING": "Loading replay data...",
  "TIGER_REPLAY_STARTING": "Starting replay...",
  "TIGER_REPORT_APRIL": "April",
  "TIGER_REPORT_AUGUST": "August",
  "TIGER_REPORT_DECEMBER": "December",
  "TIGER_REPORT_FEBRUARY": "February",
  "TIGER_REPORT_JANUARY": "January",
  "TIGER_REPORT_JULY": "July",
  "TIGER_REPORT_JUNE": "June",
  "TIGER_REPORT_MARCH": "March",
  "TIGER_REPORT_MAY": "May",
  "TIGER_REPORT_MONTH": "Month",
  "TIGER_REPORT_NOVEMBER": "November",
  "TIGER_REPORT_NO_TIMES": "No recorded times.",
  "TIGER_REPORT_OCTOBER": "October",
  "TIGER_REPORT_SEPTEMBER": "September",
  "TIGER_REPORT_YEAR": "Year",
  "TIGER_REPORT_YEAR_INVALID": "Enter a four-digit year.",
  "TIGER_RESTORE_DESKTOP_ONLY": "Restore is only available in the desktop app.",
  "TIGER_RESTORE_LOCATION_FIELD": "restore location",
  "TIGER_RES_BUSY": "Busy",
  "TIGER_RES_DISMISS": "Dismiss",
  "TIGER_RES_END": "End",
  "TIGER_RES_NO_SERVER_RESPONSE": "No response from server - the data request may have failed.",
  "TIGER_RES_PLEASE_WAIT": "Please Wait",
  "TIGER_RES_START": "Start",
  "TIGER_RES_WORKING": "Working...",
  "TIGER_TOOLREPORT_FILE_NAME": "File name",
  "TIGER_TOOLREPORT_FILE_NAME_ARIA": "report file name",
  "TIGER_TOOLREPORT_FORMAT": "Format",
  "TIGER_TOOLREPORT_FORMAT_DOC": "Tiger Office Report (.doc)",
  "TIGER_TOOLREPORT_FORMAT_FODT": "Tiger LibreOffice Report Template (.fodt)",
  "TIGER_TOOLREPORT_FORMAT_ODT": "Tiger LibreOffice Report (.odt)",
  "TIGER_TOOLREPORT_FORMAT_XML": "Tiger Office Report Template (.xml)",
  "TIGER_TOOLSETS_FILTER": "Tiger Toolset (*.ini)",
  "TIGER_TREND_ENTER_TIMES": "Enter both start and end date/time.",
  "TIGER_TREND_NO_TAGS": "No tags in this trend.",
  "TIGER_TREND_TAGS": "Tags",
  "TIGER_UI_CONNECTING_SERVER_MSG": "Connecting to the Tiger server.\nPlease wait until the connection is established...",
  "TIGER_UI_CONNECTING_SERVER_TITLE": "Connecting to Server",
  // Startup step list under the "Connecting to Server" message. The backend
  // (comms::startup_progress) sends the id plus its %s arguments, so these
  // are format strings and a site lang file can override any of them.
  "TIGER_UI_STARTUP_CONNECTING": "Connecting to the Tiger server (%s)",
  "TIGER_UI_STARTUP_CONNECTED": "Connected to the Tiger server (%s)",
  "TIGER_UI_STARTUP_TUNNEL": "Connecting to the tunnel server",
  "TIGER_UI_STARTUP_TUNNEL_READY": "Connected to the tunnel server",
  "TIGER_UI_STARTUP_CHECK_CONFIG": "Checking %s (%s of %s)",
  "TIGER_UI_STARTUP_CHECKS_DONE": "Version checks complete",
  "TIGER_UI_HIDE_TREE": "Hide tree",
  "TIGER_UI_IMPORT_CSD_MSG": "Processing data.  Please wait...",
  "TIGER_UI_MODE_LIVE": "LIVE",
  "TIGER_UI_MODE_REPLAY": "REPLAY",
  "TIGER_UI_MODE_SWITCH_LABEL": "Live or Replay mode",
  "TIGER_UI_MODE_TIP_LIVE": "Live - click to switch to Replay",
  "TIGER_UI_MODE_TIP_REPLAY": "Replay - click to switch to Live",
  "TIGER_UI_PICK_A_DATE": "Pick a date",
  "TIGER_UI_PRINT_VIEW_TITLE": "Tiger View",
  "TIGER_UI_REPLAY_CONTROLS": "Replay controls",
  "TIGER_UI_RT_CONTINUE": "Continue",
  "TIGER_UI_RT_FASTER": "Faster",
  "TIGER_UI_RT_JUMP_BACK": "Jump back",
  "TIGER_UI_RT_JUMP_BACK_60": "Jump back 60s",
  "TIGER_UI_RT_JUMP_FORWARD": "Jump forward",
  "TIGER_UI_RT_JUMP_FORWARD_60": "Jump forward 60s",
  "TIGER_UI_RT_LOAD_DATA": "Load data",
  "TIGER_UI_RT_PAUSE": "Pause",
  "TIGER_UI_RT_RATE_DOWN": "Rate down",
  "TIGER_UI_RT_RATE_UP": "Rate up",
  "TIGER_UI_RT_SLOWER": "Slower",
  "TIGER_UI_RT_START": "Start",
  "TIGER_UI_RT_START_REPLAY": "Start replay",
  "TIGER_UI_RT_STEP": "Step",
  "TIGER_UI_RT_STEP_ONE": "Step one sample",
  "TIGER_UI_RT_STOP": "Stop",
  "TIGER_UI_RT_STOP_REPLAY": "Stop replay",
  "TIGER_UI_SHOW_TREE": "Show tree",
  "TIGER_UI_TIGER_BINARY_FILES": "Tiger Binary Files",
  "TIGER_VERSION_BACKING_UP": "Backing up",
  "TIGER_VERSION_BACKUP_TITLE": "Backing Up Tiger",
  "TIGER_VERSION_BINARY": "Binary (%s)",
  "TIGER_VERSION_CHECK_MSG": "Tiger has detected that the config and views are more recent. Would you like to update the config and views now.",
  "TIGER_VERSION_CHECK_TITLE": "Version Check for %s",
  "TIGER_VERSION_CLIENT": "Client",
  "TIGER_VERSION_COMPONENT": "Component",
  "TIGER_VERSION_CONFIGURATION": "Configuration",
  "TIGER_VERSION_LATER": "Later",
  "TIGER_VERSION_MISSING_MSG_PRE": "This turbine is not installed on this PC. Select ",
  "TIGER_VERSION_NOT_INSTALLED": "Not installed",
  "TIGER_VERSION_RESTART_MSG": "Tiger has been updated and must be restarted to apply the changes.",
  "TIGER_VERSION_RESTART_NOW": "Restart Now",
  "TIGER_VERSION_RESTART_REQUIRED": "Restart Required",
  "TIGER_VERSION_SERVER": "Server",
  "TIGER_VERSION_UPDATE_MSG_MID": " to download and apply, or ",
  "TIGER_VERSION_UPDATE_MSG_POST": " to defer.",
  "TIGER_VERSION_UPDATE_MSG_PRE": "Updates are available for the following components. Select ",
  "TIGER_VERSION_UPDATE_TITLE": "Tiger Update Available - %s",
  "TIGER_VIEW_SHOW_GRAPH": "Show Graph",
  "TIGER_WIDGET_SPREAD_FOR": "Spread for ",
  "TIGER_WIDGET_TOOLTIP_DIGITAL": " [DIGITAL] ",
  "TIGER_REPORT_FILTER_DOC": "Tiger Office Report",
  "TIGER_REPORT_FILTER_ODT": "Tiger LibreOffice Report",
  "TIGER_REPORT_FILTER_XML": "Tiger Office Report Template",
  "TIGER_REPORT_FILTER_FODT": "Tiger LibreOffice Report Template",
  "TIGER_REPORT_FILTER_DOCX": "Tiger MSOffice Report",
  "TIGER_REPORT_FILTER_PDF": "Tiger PDF Report",
  "TIGER_REPORT_FILTER_XLSX": "Tiger Excel Report",
  "TIGER_REPORT_FILTER_STABILITY_DOC": "Stability Office Report",
  "TIGER_REPORT_FILTER_STABILITY_ODT": "Stability LibreOffice Report",
  "TIGER_REPORT_FILTER_EVENT": "Save Event Report File",
  "TIGER_REPORT_REQUEST_FAILED": "Report request failed (%s)",
  "TIGER_REPORT_CONVERT_FAILED_ORIGINAL": "The report could not be converted to .%s, so it was downloaded in its original format as %s.\n\n%s",
  "TIGER_IMPORT_CSD_TITLE": "Import CSD File",
  "TIGER_IMPORT_CSD_SUCCESS": "Import CSD data succeeded",
  "TIGER_IMPORT_CSD_FAIL": "Import CSD data failed",
};
